import { render } from "./vdvcedit.vue?vue&type=template&id=7e031844&scoped=true"
import script from "./vdvcedit.vue?vue&type=script&lang=js"
export * from "./vdvcedit.vue?vue&type=script&lang=js"

import "./vdvcedit.vue?vue&type=style&index=0&id=7e031844&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e031844"]])

export default __exports__